import { IosCloseButton } from 'components/iOSCloseButton';
import { useMobileLayout } from 'hooks/useMobileLayout';
import * as React from 'react';
import styled from 'styled-components';

interface Props {
  url: string;
  onClose: () => void;
}

const Wrapper = styled.div`
  background: black;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
  }

  button {
    position: fixed;
    top: 0;
    right: 0;
  }
`;

export const VideoPlayer: React.FC<Props> = ({ url, onClose }) => {
  const isWebApp = useMobileLayout();
  const videoRef = React.useRef<HTMLVideoElement>(null);

  React.useEffect(() => {
    if (!videoRef.current) {
      return;
    }
    videoRef.current.addEventListener('webkitendfullscreen', onClose);
    return () => {
      videoRef.current?.removeEventListener('webkitendfullscreen', onClose);
    };
  }, [onClose]);

  return (
    <Wrapper>
      <video ref={videoRef} controls={true} autoPlay={true} playsInline={true}>
        <source src={url} type="video/mp4" />
      </video>
      {isWebApp ? (
        <IosCloseButton onClick={onClose} />
      ) : (
        <button className="tertiary close close--figma" onClick={onClose} />
      )}
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/library/VideoPlayer.tsx